import { render, staticRenderFns } from "./ARadio.vue?vue&type=template&id=b2205782&scoped=true&"
import script from "./ARadio.vue?vue&type=script&lang=js&"
export * from "./ARadio.vue?vue&type=script&lang=js&"
import style0 from "./ARadio.vue?vue&type=style&index=0&id=b2205782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2205782",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio})
